import { render, staticRenderFns } from "./OSClmRIBordereaux.vue?vue&type=template&id=5700c5f3&"
import script from "./OSClmRIBordereaux.vue?vue&type=script&lang=js&"
export * from "./OSClmRIBordereaux.vue?vue&type=script&lang=js&"
import style0 from "./OSClmRIBordereaux.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports